import React, { useEffect } from "react";
import { HomeNavigation, MaintenanceNavigation, LogoutNavigation } from "@modules";
import { GlobalState, NavigationActions, SplashScreenState } from "@redux";
import { useDispatch, useSelector } from "react-redux";
import { useToggleWebsocket } from "@hooks";

export const RootNavigator: React.FC = () => {
  const {
    maintenance: { inMaintenance, isTester },
  } = useToggleWebsocket();

  const dispatch = useDispatch();

  const { isInitialLinkHandled, splashScreenState } = useSelector(
    (state: GlobalState) => state.navigation
  );

  const { isLoggingOut } = useSelector(
    (state: GlobalState) => state.auth
  );

  useEffect(() => {
    // hook to be run once when the app start to check if a deeplink opened
    if (
      !isInitialLinkHandled &&
      splashScreenState === SplashScreenState.PLAYED
    ) {
      dispatch(NavigationActions.setIsInitialLinkHandled(true));
    }
  }, [splashScreenState, isInitialLinkHandled, dispatch]);

    // 1) Maintenance mode trumps everything
    if (inMaintenance && !isTester) {
      return <MaintenanceNavigation />;
    }

    // 2) If we’re in the middle of logging out, render ONLY the logout stack
    if (isLoggingOut) {
      return (
          <LogoutNavigation />
      );
    }

    // 3) Otherwise branch on logged-in vs. logged-out
    return (
      <>
      <HomeNavigation />
      </>
    );
};
